import styled from 'styled-components'

export const ContainerDiv = styled.div`
  width: 627px;
  min-height: 150px;
  border-radius: 50px 0 0 50px;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  .scheduleNotReady {
    margin-bottom: 30px;
  }
  .header {
    text-transform: uppercase;
    font-family: StolzlMedium, serif;
    font-size: 20px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: 2px;
    color: #000;
  }
  .innerDiv {
    padding: 62px 0 0 70px;
  }
  .entries {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin-top: 34px;
  }
`
